// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const ZoomOut = ({ size, stroke, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="2px"
    >
      <circle cx="20.67" cy="20.67" r="18" />
      <line x1="45.73" y1="45.65" x2="33.44" y2="33.35" />
      <path d="M30.79,20.71H10.79s20,0,20,0Z" />
    </svg>
  );
};
